// extracted by mini-css-extract-plugin
export default {"root":"IconCalendar_root__tsU5s"};